import { render, staticRenderFns } from "./FormBlockBuilder.vue?vue&type=template&id=03821e3e&scoped=true&"
import script from "./FormBlockBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBlockBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormBlockBuilder.vue?vue&type=style&index=0&id=03821e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03821e3e",
  null
  
)

export default component.exports